const createStorageHelper = (storageName: "localStorage" | "sessionStorage") => {
	const getStorage = () => globalThis[storageName];

	const helper = {
		isAvailable: (() => {
			try {
				if (typeof getStorage() === "undefined") {
					return false;
				}

				const testKey = "__storage_test__";
				getStorage().setItem(testKey, testKey);
				getStorage().removeItem(testKey);
				return true;
			} catch (_e) {
				return false;
			}
		})(),

		getItem: (key: string, defaultValue = null) => {
			try {
				const item = getStorage().getItem(key);
				return item ? JSON.parse(item) : defaultValue;
			} catch (_e) {
				return defaultValue;
			}
		},

		setItem: (key: string, value: any): boolean => {
			if (!helper.isAvailable) {
				return false;
			}

			try {
				getStorage().setItem(key, JSON.stringify(value));
				return true;
			} catch (_e) {
				return false;
			}
		},

		removeItem: (key: string): boolean => {
			if (!helper.isAvailable) {
				return false;
			}

			try {
				getStorage().removeItem(key);
				return true;
			} catch (_e) {
				return false;
			}
		},

		clear: (): boolean => {
			if (!helper.isAvailable) {
				return false;
			}

			try {
				getStorage().clear();
				return true;
			} catch (_e) {
				return false;
			}
		},

		clearExcept: (preservedPrefixes: string[]): boolean => {
			if (!helper.isAvailable) {
				return false;
			}

			try {
				const storage = getStorage();
				const keysToRemove: string[] = [];
				for (let i = 0; i < storage.length; i++) {
					const key = storage.key(i);
					if (key !== null && !preservedPrefixes.some((prefix) => key.startsWith(prefix))) {
						keysToRemove.push(key);
					}
				}
				for (const key of keysToRemove) {
					storage.removeItem(key);
				}
				return true;
			} catch (_e) {
				return false;
			}
		},
	};

	return helper;
};

export const localStorageHelper = createStorageHelper("localStorage");

export const sessionStorageHelper = createStorageHelper("sessionStorage");
